"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.Vehicle = function (props) {
  var _a;

  return react_1.default.createElement("svg", __assign({}, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-1277",
    d: "M35.813,28.426c0.211,0.301,0.24,0.693,0.075,1.021l-1,2c-0.147,0.298-0.436,0.502-0.765,0.545 C33.805,32.033,26.296,33,23.994,33c-2.301,0-9.809-0.967-10.127-1.008c-0.331-0.043-0.618-0.247-0.766-0.545l-1-2 c-0.164-0.328-0.135-0.721,0.076-1.021c0.211-0.301,0.564-0.461,0.936-0.419C13.196,28.017,21.57,29,23.994,29 c2.427,0,10.8-0.983,10.884-0.993C35.237,27.965,35.603,28.124,35.813,28.426z M45.994,24v7c0,0.859-0.315,1.588-1,2.202V37 c0,0.553-0.452,1-1.005,1h-5.947c-0.553,0-1.048-0.447-1.048-1v-1.485c-3.269,0.337-7.538,0.485-13,0.485 c-5.459,0-9.729-0.148-13-0.485V37c0,0.553-0.453,1-1.005,1H4.042c-0.552,0-1.048-0.447-1.048-1v-3.798 c-0.682-0.614-1-1.343-1-2.202v-7c0-2.166,1.242-3.975,3.662-5.393l-1.978-0.658C3.271,17.812,2.994,17.431,2.994,17v-1 c0-0.553,0.449-1,1-1h3c0.288,0,0.542,0.124,0.724,0.316l1.382-2.764C10.211,10.332,18.909,10,23.994,10 c5.086,0,13.786,0.332,14.895,2.553l1.384,2.764C40.453,15.123,40.708,15,40.994,15h3c0.554,0,1,0.447,1,1v1 c0,0.431-0.274,0.812-0.683,0.949l-1.977,0.658C44.755,20.025,45.994,21.833,45.994,24z M8.522,18.18 C11.025,18.463,16.733,19,23.994,19c7.27,0,12.972-0.537,15.474-0.819l-2.367-4.733C36.323,12.601,29.687,12,23.994,12 c-5.69,0-12.327,0.602-13.135,1.495L8.522,18.18z M8.994,35.268c-1.647-0.244-2.966-0.555-4-0.94V36h4V35.268z M42.994,34.327 c-1.03,0.386-2.351,0.696-4,0.94V36h4V34.327z M43.994,24c0,2-11,2-11,1c0-1.273,8-2,9-2c1.284,0,1.77,0.004,1.931,0.447 c-0.34-1.939-2.359-3.022-3.121-3.413C39.284,20.229,32.733,21,23.994,21c-8.738,0-15.288-0.771-16.807-0.966 c-0.762,0.391-2.781,1.474-3.123,3.413C4.225,23.004,4.713,23,5.994,23c1,0,9,0.727,9,2c0,1-11,1-11-1v7c0,1.99,6.729,3,20,3 c13.272,0,20-1.01,20-3V24z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-1277"
  }));
};